/**
 * @generated SignedSource<<b7aea5adbe76a9624793654afc4815d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber$data = {
  readonly formattedNumberValue: string | null;
  readonly numberValue: number | null;
  readonly " $fragmentType": "WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber";
};
export type WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber$key = {
  readonly " $data"?: WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedNumberValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionNumber",
  "abstractKey": null
};

(node as any).hash = "7ca2e6405edf8a6a810ee386add0ddd8";

export default node;
